// extracted by mini-css-extract-plugin
export default {"svgLoader":"Loader_svgLoader__FzJ5c","spin":"Loader_spin__E4RJ0","loader":"Loader_loader__+lRPl"};